import * as React from "react";
import { MarketsCount } from "../MarketsCount";
import { IconsController } from "../IconsController";
export const IconsWrapper = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__icons-holder`, "data-uat": `div-ev-list-${props.componentPrefix}-icons-holder` },
    React.createElement(IconsController, Object.assign({}, props.details)),
    !props.details.isDesktop &&
        React.createElement(MarketsCount, { count: props.details.event.marketLinesCount, componentPrefix: props.componentPrefix }));
//# sourceMappingURL=IconsWrapper.js.map